/**
 * Compose the hover-tooltip text for a single leaf, matching phylocanvas's
 * node tooltip: the node id on the first line, then one `field: value` line per
 * chosen metadata field that has a value.
 *
 * The SVG renderer feeds this the block cells it last received for the leaf
 * (`field -> { label }`), so the tooltip reuses the exact values already shown
 * in the metadata blocks -- no separate data path. With no `fields` selected the
 * tooltip shows every non-empty value (phylocanvas's show-all default); empty,
 * missing, and unknown fields are skipped. The result is plain text (newline
 * separated) for the native `title` tooltip the vendored library uses.
 */
export function buildTooltipText(
  nodeId: string,
  fields: string[],
  row: Record<string, { label?: string }> | undefined,
): string {
  if (!row) return nodeId;
  const keys = fields.length > 0 ? fields : Object.keys(row);
  const lines = [nodeId];
  for (const key of keys) {
    const value = row[key]?.label;
    if (value == null || value === '') continue;
    lines.push(`${key}: ${value}`);
  }
  return lines.join('\n');
}
